import {
  CHANGE_CASH_COUNT,
  CHANGE_SERUM_COUNT,
  CHANGE_USER_LOGIN_STATUS,
  CHANGE_USER_PRIME_DATA,
  GET_USER_PRIME_STATUS,
  SHOW_AUTH_MODAL,
  STORE_USER_DATA,
  STORE_WALLET_DATA,
} from '../../actions/types';
import {getUserPrimeData} from '../../../helpers/util';

const authToken = localStorage.getItem('auth-token');
const {isPrime, videoPass, testPass} = getUserPrimeData(authToken);

const initialState = {
  isUserLoggedIn: authToken !== null,
  isUserPrime: isPrime,
  videoPass,
  testPass,
  showAuthModal: false,
  userData: {
    id: '',
    name: '',
    email: '',
    mbbsPercentage: '',
    state: '',
    userName: '',
    countryData: {
      name: '',
      dialCode: '',
      countryCode: '',
    },
    university: '',
    category: '',
    contactNumber: '',
    emailVerified: true,
    avatarUrl: '',
    batch: '',
    qualification: '',
    specialization: '',
  },
  walletData: {
    serum: 0,
    cash: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_USER_LOGIN_STATUS:
      return {
        ...state,
        isUserLoggedIn: action.payload,
      };
    case CHANGE_USER_PRIME_DATA:
      return {
        ...state,
        isUserPrime: action.payload.isPrime,
        videoPass: action.payload.videoPass,
        testPass: action.payload.testPass,
      };
    case GET_USER_PRIME_STATUS:
      return {
        ...state,
        isUserPrime: action.payload,
      };
    case SHOW_AUTH_MODAL:
      return {
        ...state,
        showAuthModal: action.payload,
      };
    case STORE_USER_DATA:
      const {userData, walletData} = action.payload;
      return {
        ...state,
        userData,
        walletData,
      };
    case CHANGE_SERUM_COUNT:
      return {
        ...state,
        walletData: {
          ...state.walletData,
          serum: action.payload,
        },
      };
    case CHANGE_CASH_COUNT:
      return {
        ...state,
        walletData: {
          ...state.walletData,
          cash: action.payload,
        },
      };
    case STORE_WALLET_DATA:
      return {
        ...state,
        walletData: action.payload,
      };
    default:
      return state;
  }
};

